// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"964f60a3","422":"671b309a","673":"6788eaa1"}[chunkId] + ".chunk.js";
};